import React from "react";
import './Link.css';


const Link2 = () => {
  return (
    <div className="links">
    <div className="container">
    <div className="column">
    <h3 className="perfect" style={{marginTop : "170px"}}>Changing a CO<sub>2</sub> Cylinder (Ice Bank Cooler)</h3>
    <br />
    </div>

    <div className="cardstart" style={{marginTop : "30px"}}>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link21.webp">
          <source src="link21.mp4" type="video/mp4" />
        </video>
              </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 1 :  </b>Slow beer flow may indicate that the CO<sub>2</sub> cylinder is empty</h5>
      </div>
    </div>

     
<div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link22.webp">
          <source src="link22.mp4" type="video/mp4" />
        </video>
              </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 2 :  </b>Ensure that the pressure on the CO<sub>2</sub> meter indicates zero</h5>
      </div>
    </div>
 
    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link23.webp">
          <source src="link23.mp4" type="video/mp4" />
        </video>
              </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 3 :  </b>Turn off the CO<sub>2</sub> flow by turning the knob on the cylinder clockwise
           </h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link24.webp">
          <source src="link24.mp4" type="video/mp4" />
        </video>
              </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 4 :  </b>Release the residue pressure by pulling on the release key repeatedly before unscrewing the nut with a spanner</h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link25.webp">
          <source src="link25.mp4" type="video/mp4" />
        </video>
              </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 5 :  </b>Ensure that there is a washer on the regulator before connecting it to the new CO<sub>2</sub> cylinder
        <b style={{fontWeight:'500', fontSize:'1rem' , marginLeft:'5px'}}>(IMPORTANT) The washer prevents any potential CO2 leaks </b> </h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link26.webp">
          <source src="link26.mp4" type="video/mp4" />
        </video>
              </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 6 :  </b>After connecting the regulator to a new cylinder, tighten the nut with a spanner
        <b style={{fontWeight:'500', fontSize:'1rem' , marginLeft:'5px'}}>(IMPORTANT) Double check that the nut is properly tightened</b> </h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link27.webp">
          <source src="link27.mp4" type="video/mp4" />
        </video>
              </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 7 :  </b>Turn on the CO<sub>2</sub> flow by turning the cylinder knob anti-clockwise</h5>
      </div>
    </div>
</div>

<div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link28.webp">
          <source src="link28.mp4" type="video/mp4" />
        </video>
              </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 8 :  </b>Start dispensing the beer and stop when there is clear beer flow</h5>
      </div>
    </div>
</div>
    
    </div>

    )
}

export default Link2;
